import { Injectable, WritableSignal, signal, EventEmitter } from '@angular/core';

import { TimeRange, BenchmarkDashboardDatapoint, EngergyDashboardData, ValueAggregation } from "./benchmark-dashboard.data.interface";




@Injectable()
export class BenchmarkDashboardStorageService {

    public onPropertyChanged: EventEmitter<any> = new EventEmitter()

    private compareRangeTime = 0;
    public set(property, value){
   
        // Dirty hack to avoid overwriting with an old value
        if(property === 'compareRange') {
            if(this.compareRangeTime - 200 >= Date.now()) {
                this.compareRangeTime = Date.now();
                return;
            }
            this.compareRangeTime = Date.now();
        }
        //.update((errors: any) => ([...errors, error]));
        this.data.update((data) => {
            data[property] = value
            return data;
        });
        this.onPropertyChanged.emit({ property, value})
    }

    public data : WritableSignal<EngergyDashboardData> = signal({
        aggregationRange : TimeRange.day,
        valueAggregation : ValueAggregation.average,
        compareRange: TimeRange.year,
        from: Date.now() - (1000 * 60 * 60 * 24),
        to: Date.now(),
        showSeriesLabel: true,
        charts : [
            {
                datapoints : []
            }
        ]
    });

    public importDashboard(benchmarkDashboard: string) {
        const importData = JSON.parse(benchmarkDashboard);
        this.data.update((data) => {
            Object.keys(importData).forEach((key) => {
                data[key] = importData[key];
            })
            return data;
        })
    }

    public exportDashboard() {
        return JSON.stringify(this.data(), null, '  ');
    }

    public addDatapoint(datapoint: BenchmarkDashboardDatapoint, chartIndex = 0){
        if(!this.data().charts[chartIndex].datapoints.find((current) => {
            return current.datapointId === datapoint.datapointId
                &&  current.plantId === datapoint.plantId
        })){
            this.data.update((data) =>  {
                data.charts[chartIndex].datapoints.push(datapoint);
                return data;
            })
            this.onPropertyChanged.emit({ property : 'datapoint', value : datapoint})
        }
    }


    public updateDatapoint(datapoint: BenchmarkDashboardDatapoint, chartIndex = 0){
        this.data.update((data) => {
            let hasChanged = false;
            data.charts[chartIndex].datapoints = data.charts[chartIndex].datapoints.map((current: BenchmarkDashboardDatapoint) => {
                // only update datapoint if values has changed
                if(current.plantId === datapoint.plantId && current.datapointId === datapoint.datapointId) {
                    if(current.name !== datapoint.name || current.color !== datapoint.color) {
                        hasChanged = true;
                    }
                    return datapoint;
                }
                return current;
            })
            if(hasChanged) {
                this.onPropertyChanged.emit({ property : 'datapoint', value : data.charts[chartIndex].datapoints})
            }
            return data;
        })
    }

    public updateDatapointsOrder(datapoints: BenchmarkDashboardDatapoint[], chartIndex = 0){
        if(!this.data().charts[chartIndex].datapoints) {
            return;
        }
        const orderChanged = this.data().charts[chartIndex].datapoints.find((current, index) => {
            return current.plantId != datapoints[index].plantId
                || current.datapointId != datapoints[index].datapointId
        })
        if(orderChanged) {
            this.data.update((data) => {
                data.charts[chartIndex].datapoints = datapoints;
                return data;
            })

            this.onPropertyChanged.emit({ property : 'datapoint', value : datapoints})
        }
    }

    public removeDatapoint(datapoint: BenchmarkDashboardDatapoint, chartIndex = 0){
        this.data.update((data) => {
            data.charts[chartIndex].datapoints = data.charts[chartIndex].datapoints.filter((current) => {
                return !(current.datapointId === datapoint.datapointId && current.plantId === datapoint.plantId)
            })
            return data;
        });
        this.onPropertyChanged.emit({ property : 'datapoint', value : datapoint})
    }


    public reset(){
        this.data = signal({
            aggregationRange : TimeRange.day,
            valueAggregation : ValueAggregation.average,
            compareRange: TimeRange.year,
            from: Date.now() - (1000 * 60 * 60 * 24),
            to: Date.now(),
            showSeriesLabel: true,
            charts : [
                {
                    datapoints : []
                }
            ]
        });
   }

}